import { createStorefrontApiClient } from '../Services/StoreFrontApiClient';
import { DecorationTypeKey, GlobalProductOptionsConfiguration } from './Product.DecoTypeDeclaration';

export const getGlobalProductOptionsConfiguration = async (): Promise<GlobalProductOptionsConfiguration> => {
  const PRODUCT_OPTIONS_CONFIGURATION_HANDLE = 'product-options-configuration';
  const PRODUCT_OPTIONS_CONFIGURATION_METAFIELD_KEY = 'product_options_config';
  const PRODUCT_OPTIONS_CONFIGURATION_METAFIELD_NAMESPACE = 'alc_pricing';

  const collectionQuery = {
      query: `query {
        collection (handle: \"${PRODUCT_OPTIONS_CONFIGURATION_HANDLE}\") {
          id
          title
          handle
          metafield(
            key: \"${PRODUCT_OPTIONS_CONFIGURATION_METAFIELD_KEY}\", 
            namespace: \"${PRODUCT_OPTIONS_CONFIGURATION_METAFIELD_NAMESPACE}\"
          ) {
            id
            key
            value
            description
          }
        }
      }`
  }

  const storefrontClient = createStorefrontApiClient();

  const collectionQueryResponse = await storefrontClient.post('', collectionQuery)
    .catch(error => {
      console.error(error);
      
      return { 
        success: false, 
        error_message: error.message
      };
    });

  const collectionQueryData = collectionQueryResponse;

  if (!collectionQueryData || (collectionQueryData.success === false) || !collectionQueryData.data) {
    return null;
  }
  let productOptionsConfiguration = null;

  if(collectionQueryData.data.collection.metafield &&
    collectionQueryData.data.collection.metafield.value) {
      productOptionsConfiguration = JSON.parse(collectionQueryData.data.collection.metafield.value);
  }
  
  return productOptionsConfiguration; 
}

export const getSelectedProductDecorationType = () : string | null => {
  const selectedDecorationFeeValue = $('input[name="properties[_Decoration type]"]:checked').val();
  let selectedDecorationTypeKey = null;

  //Temporal Key Mapping until using the noramlized value keys
  switch (selectedDecorationFeeValue) {
    case 'Hard Goods - Screen Printed (1 Color)':
    case 'Screen Printed (1-2 Colors)':
      selectedDecorationTypeKey = DecorationTypeKey.DECORATION_TYPE_SCREEN_PRINT;
      break;
    case 'Laser Engraved':
      selectedDecorationTypeKey = DecorationTypeKey.DECORATION_TYPE_LASER_ENGRAVED;
      break;
    case 'Printed':
    case 'Print':
      selectedDecorationTypeKey = DecorationTypeKey.DECORATION_TYPE_DIGITAL_PRINT;
      break;
    case 'Debossed':
      selectedDecorationTypeKey = DecorationTypeKey.DECORATION_TYPE_DEBOSSED;
      break;
    case 'Heat Transfer':
      selectedDecorationTypeKey = DecorationTypeKey.DECORATION_TYPE_HEAT_TRANSFER;
      break;
  };

  return selectedDecorationTypeKey;
}
